export default __webpack_public_path__ + "static/media/iDocCarFont.6c19d9a6.woff";